export default __webpack_public_path__ + "static/AgriculturalZoning-486abead776b9b4caade908afcd3229b.jpg";